"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueGreaterThanOrEqualTo = function (value, comparedValue) {
    if (value == null) {
        return false;
    }
    if (typeof value !== 'number') {
        return false;
    }
    if (typeof comparedValue !== 'number') {
        return true;
    }
    return value >= comparedValue;
};
exports.isNullOrDefault = function (value) {
    return value == null || value === '' || value === 0;
};
